import { useQuery } from "react-query";
import { fetchPlanState } from "../lib/billingApi";

// Single source of truth for the current user's effective plan (LTD + SaaS merged),
// replacing the legacy subsInfo.details plan-slug reads. react-query dedupes the
// request across every component that calls this hook.
export function usePlanState() {
    const { data, isLoading, refetch } = useQuery("planState", fetchPlanState, {
        staleTime: 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
    });
    return {
        planState: data || null,
        effectivePlan: data?.effective_plan || "free",
        isLoading,
        refetch,
    };
}
